import React, { useEffect, useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification, Select } from "antd";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { orderList } from "../../../controllers/V1/cms/campaignController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common";
import moment from "moment";
import { usePermissions } from "../../../controllers/PermissionContext";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {list as generalData} from "../../../controllers/V1/cms/generalDataController";
import { list as campaignList } from "../../../controllers/V1/cms/campaignController";
// import SelectCampaign from "../../../components/SelectCampaigns";

const EXPORT_SELECT_ACCOUNT = {
  order_no: true,
  seller_pos_number: true,
  campaign_title: true,
  seller_area: true,
  seller_mobile: true,
  bind_person_name: true,
  status: true,
  total_qty: true,
  total_points: true,
  createdAt: true,
  seller_user_id: true,
};

const EXPORT_SELECT_DRAW = {
  ...EXPORT_SELECT_ACCOUNT,
  ticket: true,
};
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const PERMISSION = usePermissions("campaignOrder");
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Preparing download...");
  const [error, setError] = useState(null);

  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  const [todayTime, setTodayTime] = useState('00:00');
  const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  const [yesterdayTime, setYesterdayTime] = useState('00:01');

  const [campaignData, setCampaignData] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [searchText, setSearchText] = useState("");
  const debounceTimeout = useRef(null);

  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    setError(null); // Reset the error state before each request
  
    try {
      setIsLoading(true);
      setLoadingText("Fetching orders...");
      const formData = new FormData(e.target);

      const isDrawExport =
        formData.get("exportType") === "Draw" &&
        (PERMISSION?.fullAccess === "Y" || PERMISSION?.exportType === "Y");
      // Default export type when permission hides the selector is Account-style
      // (no ticket expand) unless Draw is explicitly chosen.
      const exportType = isDrawExport ? "Draw" : (formData.get("exportType") || "Account");
  
      const baseCondition = {
        ...(formData.get("order_no") && { order_no: formData.get("order_no") }),
        ...(formData.get("campaign_title") && {
          campaign_title: {
            $regex: formData.get("campaign_title"),
            $options: "i",
          },
        }),
        ...( selectedCampaigns.length > 0 && { campaign_data : {$in : selectedCampaigns } } ),
        ...(formData.get("seller_first_name") && {
          seller_first_name: {
            $regex: formData.get("seller_first_name"),
            $options: "i",
          },
        }),
        ...(formData.get("seller_last_name") && {
          seller_last_name: {
            $regex: formData.get("seller_last_name"),
            $options: "i",
          },
        }),
        ...(formData.get("seller_mobile") && {
          seller_mobile: parseInt(formData.get("seller_mobile")),
        }),
        ...(formData.get("seller_pos_number") && {
          seller_pos_number: parseInt(formData.get("seller_pos_number")),
        }),
        ...(formData.get("status") && { status: formData.get("status") }),
  
        createdAt: {
          $gte: `${yesterdayDate} ${yesterdayTime}`,
          $lte: `${todayDate} ${todayTime}`,
        },
      };

      // Smaller Draw batches: ticket populate is heavy under peak write load
      const pageSize = isDrawExport ? 2000 : 1000;
  
      let allResults = [];
      let hasMore = true;
      let cursor = null;
  
      while (hasMore) {
        const option = {
          isExport: true,
          useCursor: true,
          exportType,
          condition: baseCondition,
          select: isDrawExport ? EXPORT_SELECT_DRAW : EXPORT_SELECT_ACCOUNT,
          sort: { _id: -1 },
          limit: pageSize,
          ...(cursor ? { cursor } : { cursor: null }),
        };

        const res = await orderList(option);
        if (res?.status === true && res?.result?.length > 0) {
          allResults.push(...res.result);
          setLoadingText(`Fetched ${allResults.length} orders...`);
          cursor = res.nextCursor || res.result[res.result.length - 1]?._id;
          hasMore = res.result.length >= pageSize;
          if (hasMore) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        } else {
          hasMore = false;
        }
      }
  
      if (allResults.length > 0) {
        setLoadingText("Building Excel file...");
        if (isDrawExport) {
          await exportDrawData(allResults);
        } else {
          await exportAccountData(allResults);
        }
        handleCancel();
      } else {
        setIsLoading(false);
        notification.open({
          message: "Oops!",
          description: `No records found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `An error occurred while exporting the data.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };
  

  const createPurchaseDateFormatter = () => {
    const cache = new Map();
    return (createdAt) => {
      const key = String(createdAt);
      if (!cache.has(key)) {
        cache.set(key, moment(formatProjectDate(createdAt)).format("YYYY-MM-DD HH:mm"));
      }
      return cache.get(key);
    };
  };

  const exportDrawData = async (result) => {
    try {
      const formatPurchaseDate = createPurchaseDateFormatter();
      const includeCoupons = PERMISSION.fullAccess === "Y" || PERMISSION.coupon === "Y";
      const rows = [];
      let i = 0;

      for (const item of result) {
        const purchaseDate = formatPurchaseDate(item.createdAt);
        const base = {
          "POS No.": item.seller_pos_number,
          "Order ID": item.order_no,
          "Product Name": item?.campaign_title,
          "Store Name": item?.seller_user_id?.store_name,
          "Seller Name": item.seller_area || "N/A",
          "Seller Mobile": item.seller_mobile,
          "Bind With": item.bind_person_name,
          "Payment Status": item.status,
          "Purchase Date": purchaseDate,
        };

        const tickets = item?.ticket;
        if (Array.isArray(tickets) && tickets.length > 0) {
          for (const value of tickets) {
            rows.push({
              "Sl.No.": ++i,
              ...base,
              "Straight Amount": value?.type === "Straight" ? "1" : "0",
              "Rumble Amount": value?.type === "Rumble" ? "1" : "0",
              "Chance Amount": value?.type === "Chance" ? "1" : "0",
              ...(includeCoupons && { Coupons: value?.ticket }),
            });
          }
        } else {
          rows.push({
            "Sl.No.": ++i,
            ...base,
            "Straight Amount": "0",
            "Rumble Amount": "0",
            "Chance Amount": "0",
            Coupons: "",
          });
        }
      }

      await exportToExcel(rows);
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: "An error occurred while preparing the export file.",
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };

  const exportAccountData = async (result) => {
    try {
      const formatPurchaseDate = createPurchaseDateFormatter();
      const rows = [];
      let i = 0;

      for (const item of result) {
        rows.push({
          "Sl.No.": ++i,
          "POS No.": item.seller_pos_number,
          "Order ID": item.order_no,
          "Product Name": item?.campaign_title,
          "Store Name": item?.seller_user_id?.store_name,
          "Seller Name": item.seller_area || "N/A",
          "Seller Mobile": item.seller_mobile,
          "Bind With": item.bind_person_name,
          "Payment Status": item.status,
          Qty: item.total_qty,
          Points: item.total_points,
          "Purchase Date": formatPurchaseDate(item.createdAt),
        });
      }

      await exportToExcel(rows);
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: "An error occurred while preparing the export file.",
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };

  const exportToExcel = async (data) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));

      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data, { skipHeader: false });
      XLSX.utils.book_append_sheet(workbook, worksheet1, "Lotto-Orders");
      XLSX.writeFile(
        workbook,
        `CROWN-KING-LOTTO-ORDERS-${moment().format("DD-MM-YYYY")}.xlsx`,
        { compression: true }
      );
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getGeneralData = async () => {
    try {
      const option ={}
      const res = await generalData(option);
      if(res?.status === true){
        const time = moment().endOf('day').format('HH:mm');
        const startTime = res?.result?.export_start_time;
        const endTime = res?.result?.export_end_time;
        setTodayTime(endTime || time);
        setYesterdayTime(startTime || time);
      }
    } catch (error) {
      
    }
  }

  const getCampaignList = async () => {
    try {
      const options = {
        condition : {
          status : "A",
          prizeData : {$exists : true},
          settingData : {$exists : true},
          ...(searchText && { title: { $regex: searchText, $options: "i" } })
        },
        select : { title : true, draw_date : true, draw_time : true },
        limit : 50
      }
      const res = await campaignList(options);
      if(res?.status === true){
        setCampaignData(
          (res.result || []).map((item) => ({
            label: item.title,
            value: item._id,
            draw_date: item.draw_date,
            draw_time: item.draw_time
          }))
        );
      }
    } catch (error) {
      
    }
  }

  const handleSearch = (searchText) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      setSearchText(searchText);
    }, 500);
  };

  useEffect(()=>{
    getGeneralData();
    getCampaignList();
  },[searchText]);


  const handleChange = (selectedValues) => {
    setSelectedCampaigns(selectedValues);

    // exactly ONE campaign selected
    if (selectedValues.length === 1) {
      const selectedCampaign = campaignData.find(
        (c) => c.value === selectedValues[0]
      );

      if (selectedCampaign?.draw_date) {
        const drawMoment = moment(selectedCampaign.draw_date);

        setTodayDate(drawMoment.format("YYYY-MM-DD"));
        setTodayTime(selectedCampaign?.draw_time);

        setYesterdayDate(
          drawMoment.clone().subtract(1, "days").format("YYYY-MM-DD")
        );
        setYesterdayTime(selectedCampaign?.draw_time);
      }
    }

    // MORE THAN ONE campaign selected → reset to current
    if (selectedValues.length > 1) {
      const now = moment();

      setTodayDate(now.format("YYYY-MM-DD"));
      setTodayTime(now.format("HH:mm"));

      setYesterdayDate(now.clone().subtract(1, "days").format("YYYY-MM-DD"));
      setYesterdayTime(now.format("HH:mm"));
    }
  };


  // const handleChange = (selectedValues) => {
  //   setSelectedCampaigns(selectedValues);
  // };

  const handleClear = async () => {
    setCampaignData([]);
    setSelectedCampaigns([]);
  }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            className="inventory_popup_title_heading"
          >
            Export Campaign Order
          </Typography>
          <Link
            to={false}
            style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }}
            onClick={handleCancel}
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
        >
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="order_no"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Order No. :
                    </label>
                    <input
                      type="text"
                      name="order_no"
                      id="order_no"
                      placeholder="Order No."
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="campaign_title"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Campaign Title :
                    </label>
                    {/* <select
                      name="campaign_title"
                      id="campaign_title"
                      className="form-control categories_select_tg_enter_product"
                      value={selectedCampaign}
                      onChange={handleCampaignChange}
                    >
                      <option value="">All Campaign</option>
                      {campaignData?.length > 0 &&
                        campaignData.map((item) => (
                          <option key={item._id || item.title} value={item.title}>
                            {item.title}
                          </option>
                        ))}
                    </select> */}
                    <Select
                      mode="multiple"
                      className="form-control"
                      // showSearch
                      placeholder={"Select Campaigns"}
                      options={campaignData}
                      value={selectedCampaigns}
                      onSearch={handleSearch}
                      showSearch={true}
                      autoClearSearchValue={false}
                      onChange={handleChange}
                      allowClear
                      onClear={handleClear}
                      filterOption={false}
                      maxTagCount={3}
                      dropdownStyle={{ zIndex: 9999999 }}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_first_name"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's first name :
                    </label>
                    <input
                      type="text"
                      name="seller_first_name"
                      id="seller_first_name"
                      placeholder="Seller's first name"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_last_name"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's last name :
                    </label>
                    <input
                      type="text"
                      name="seller_last_name"
                      id="seller_last_name"
                      placeholder="seller Last Name"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_mobile"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's mobile :
                    </label>
                    <input
                      type="text"
                      name="seller_mobile"
                      id="seller_mobile"
                      placeholder="Seller Mobile"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_pos_number"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's POS No. :
                    </label>
                    <input
                      type="text"
                      name="seller_pos_number"
                      id="seller_pos_number"
                      placeholder="Seller's POS No"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_pos_number"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Status :
                    </label>
                    <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                      <option value={'Success'} selected>Success</option>
                      <option value={'Cancel'} >Cancel</option>
                      <option value='' >All</option>
                    </select>
                   
                  </div>
                  {(PERMISSION?.fullAccess ==='Y' || PERMISSION?.exportType === 'Y') && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label
                        htmlFor="exportType"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        Export Type :
                      </label>
                      <select name="exportType" id="exportType" className="form-control categories_select_tg_enter_product">
                        <option value={'Draw'} selected>Draw</option>
                        <option value={'Account'} >Account</option>
                      </select>
                    
                    </div>
                  )}

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label
                      for="select_title"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      {" "}
                      Date specific (If any) :
                    </label>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      From :
                    </label>
                    <input
                      type="date"
                      name="valid_date"
                      id="valid_date"
                      value={yesterdayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="valid_time"
                      id="valid_time"
                      value={yesterdayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      To :
                    </label>
                    <input
                      type="date"
                      name="expire_date"
                      id="expire_date"
                      value={todayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="expire_time"
                      id="expire_time"
                      value={todayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button
                        type="button"
                        className="btn btn-light categories_cancel_button"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-danger"
                        disabled={isLoading}
                      >
                        Download Excel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: "red" }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={loadingText} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
